// extracted by mini-css-extract-plugin
module.exports = {"container":"noticebanner_container__dm_UH"};